export enum LayerTypes {
  WMS = "wms",
  EDR_OBSERVATIONS = "edr_observations",
  STATIC = "static_overlay",
  SEISMIC_EVENTS = "seismic_events",
  PRECIPITATION = "precipitation",
}
